import { render } from "./MailStatusChipComponent.vue?vue&type=template&id=11afba64&scoped=true"
import script from "./MailStatusChipComponent.vue?vue&type=script&lang=js"
export * from "./MailStatusChipComponent.vue?vue&type=script&lang=js"

import "./MailStatusChipComponent.vue?vue&type=style&index=0&id=11afba64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11afba64"]])

export default __exports__